import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Countdown } from './Countdown';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-slate-50 py-12 md:py-20 px-4" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6" data-id="element-178">
            ⏰ El precio de lanzamiento cierra en:
          </h3>
          <Countdown initialHours={12} initialMinutes={54} initialSeconds={47} data-id="element-179" />
          <p className="text-xl text-red-600 font-semibold mt-6" data-id="element-180">
            Después sube $15.000 ARS y no vuelve.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-181">
          {/* BASE */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-slate-300 rounded-xl p-8 shadow-lg" data-id="element-182">
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-183">
              🦴 RESCATE ACADÉMICO BASE
            </h3>
            <p className="text-lg text-slate-600 mb-2" data-id="element-184">12 Tomos + 6 Bonos</p>
            <p className="text-slate-500 mb-6" data-id="element-185">Toda la carrera organizada</p>

            <div className="mb-6" data-id="element-186">
              <p className="text-slate-400 line-through text-lg mb-2" data-id="element-187">
                Antes: $72.000 ARS
              </p>
              <p className="text-3xl font-bold text-slate-900" data-id="element-188">
                Hoy: $22.990 ARS
              </p>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToPricing} className="w-full bg-[#27AE60] hover:bg-[#229954] text-white font-bold py-4 rounded-lg transition-colors" data-id="element-189">
              → QUIERO MI RESCATE ACADÉMICO BASE
            </motion.button>
          </motion.div>

          {/* ÉLITE */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white border-4 border-[#F0C040] rounded-xl p-8 relative shadow-xl" data-id="element-190">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F0C040] text-slate-900 font-bold px-6 py-2 rounded-full" data-id="element-191">
              ⭐ LA MÁS ELEGIDA
            </div>

            <h3 className="text-2xl font-bold text-slate-900 mb-4 mt-4" data-id="element-192">
              🏆 RESCATE ACADÉMICO ÉLITE
            </h3>
            <p className="text-lg text-slate-600 mb-2" data-id="element-193">
              12 Tomos + 6 Bonos + 2 Ebooks Élite
            </p>
            <p className="text-slate-500 mb-6" data-id="element-194">
              Autoridad clínica + blindaje profesional
            </p>

            <div className="mb-6" data-id="element-195">
              <p className="text-slate-400 line-through text-lg mb-2" data-id="element-196">
                Antes: $128.000 ARS
              </p>
              <p className="text-3xl font-bold text-slate-900" data-id="element-197">
                Hoy: $29.990 ARS
              </p>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToPricing} className="w-full bg-[#F0C040] hover:bg-[#E0B030] text-slate-900 font-bold py-4 rounded-lg transition-colors" data-id="element-198">
              → QUIERO EL RESCATE ACADÉMICO ÉLITE
            </motion.button>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-slate-600 text-sm md:text-base" data-id="element-199">
          <span className="flex items-center gap-2" data-id="element-200">🔒 Pago 100% seguro</span>
          <span className="hidden md:inline" data-id="element-201">|</span>
          <span className="flex items-center gap-2" data-id="element-202">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="hidden md:inline" data-id="element-203">|</span>
          <span className="flex items-center gap-2" data-id="element-204">
            🛡️ Garantía 7 días sin preguntas
          </span>
          <span className="hidden md:inline" data-id="element-205">|</span>
          <span className="flex items-center gap-2" data-id="element-206">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </motion.div>
      </div>
    </section>;
}